// knowledgeDetails.pipeline.list.* — owned by the list page.
export default {
  title: 'Knowledge Bases',
  count_one: '{{count}} knowledge base',
  count_other: '{{count}} knowledge bases',
  emptyTitle: 'No knowledge bases yet',
  emptyBody:
    'Create your first knowledge base to turn documents into grounded, citable answers.',
  updated: 'Updated {{date}}',
  open: 'Open {{name}}',
  mine: 'Mine',
  docs_one: 'doc',
  docs_other: 'docs',
  chunks_one: 'chunk',
  chunks_other: 'chunks',
  tokens_one: 'token',
  tokens_other: 'tokens',
  method: 'Chunk method',
  embedding: 'Embedding model',
  source: 'Source',
  sourceLocal: 'local uploads',
  health: 'Pipeline health',
  attention: {
    empty: 'No documents yet. Add files or connect a source.',
    failed_one: '{{count}} document failed. Open to see the error and retry.',
    failed_other:
      '{{count}} documents failed. Open to see the errors and retry.',
    stuck_one: '{{count}} empty document will not parse on its own.',
    stuck_other: '{{count}} empty documents will not parse on their own.',
    cancelled_one: '{{count}} document was cancelled before it finished.',
    cancelled_other: '{{count}} documents were cancelled before they finished.',
    parsing_one: '{{count}} document is being processed.',
    parsing_other: '{{count}} documents are being processed.',
    pending_one: '{{count}} document is waiting for someone to press Parse.',
    pending_other:
      '{{count}} documents are waiting for someone to press Parse.',
  },
  ready: 'Ready',
  docsDone: '{{done}} of {{total}} documents done',
  attentionShort: {
    empty: 'No documents yet',
    failed: '{{count}} failed',
    stuck: '{{count}} empty',
    cancelled: '{{count}} cancelled',
    parsing: '{{count}} processing',
    pending: '{{count}} not parsed',
  },
  actionShort: {
    empty: 'Add a source',
    failed: 'Review',
    stuck: 'Review',
    cancelled: 'Re-parse',
    parsing: 'Watch',
    pending: 'Parse',
  },
  permission: {
    team: 'Team',
    me: 'Only me',
  },
  lastRun: 'Last run {{date}}',
  updatedShort: 'Updated {{date}}',
  createdBy: 'Created by {{name}}',
  // The card's stage names, short so six fit; the full name is in its tooltip.
  stageShort: {
    contextualise: 'Context',
  },
  status: 'Status',
  legend: 'Status legend',
  sortLabel: 'Sort',
  type: {
    label: 'Type',
    all: 'All types',
    more: 'More types ({{count}})',
    empty: 'No knowledge bases of this type.',
  },
  sort: {
    attention: 'Needs attention',
    parsing: 'Parsing',
    all: 'All',
  },
  showing: {
    attention_zero: 'Showing {{total}} · none need attention',
    parsing_zero: 'Showing {{total}} · none are being processed',
    attention_one:
      'Showing {{total}} · the {{count}} that needs attention comes first',
    attention_other:
      'Showing {{total}} · the {{count}} that need attention come first',
    parsing_one:
      'Showing {{total}} · the {{count}} being processed comes first',
    parsing_other:
      'Showing {{total}} · the {{count}} being processed come first',
    all: 'Showing {{total}} · most recently updated first',
  },
  action: {
    empty: 'Add a source',
    failed: 'See the errors and retry',
    stuck: 'Review empty documents',
    cancelled: 'Re-parse',
    parsing: 'Watch progress',
    pending: 'Parse documents',
  },
  createNote: {
    lead: 'Create knowledge base',
    before: 'lands on ',
    stage: 'Connector',
    after:
      ', the first stage — add files or connect a source there. Chunking, embedding and GraphRAG options stay in Configuration and are not needed to start.',
  },
  deleteTitle: 'Delete Knowledge Base',
  deleteAttached: 'This knowledge base is attached to the following agent(s):',
  deleteConfirm: 'Are you sure you want to delete it?',
  connector: {
    label: 'Connector',
    all: 'All connectors',
    none: 'Uploads only',
    search: 'Search connectors…',
  },
  filterMore_one: '{{count}} more',
  filterMore_other: '{{count}} more',
  filterNoMatch: 'No match.',
  filterEmpty: 'No knowledge bases match these filters.',
};
